import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const field = "w-full bg-transparent border border-white/20 px-3 py-3 text-sm focus:border-[#56ED4A] outline-none";

export const Field = ({ label, children }) => (
  <label className="flex flex-col gap-1">
    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{label}</span>
    {children}
  </label>
);

export const FormDialog = ({ open, onOpenChange, title, onSubmit, children, testId }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#121216] border-white/10 max-w-2xl max-h-[90vh] overflow-y-auto" data-testid={`${testId}-dialog`}>
      <DialogHeader><DialogTitle className="font-display uppercase text-3xl tracking-normal">{title}</DialogTitle></DialogHeader>
      <form onSubmit={onSubmit} className="grid sm:grid-cols-2 gap-4">
        {children}
        <button data-testid={`${testId}-save-btn`} className="sm:col-span-2 bg-[#56ED4A] text-black py-4 font-mono uppercase tracking-[0.2em] text-sm font-semibold">Save</button>
      </form>
    </DialogContent>
  </Dialog>
);

export const RowActions = ({ onEdit, onDelete, testId }) => (
  <div className="flex gap-2">
    <button data-testid={`${testId}-edit-btn`} onClick={onEdit} className="font-mono text-[11px] uppercase tracking-[0.2em] border border-white/20 px-3 py-2 hover:border-[#56ED4A]">Edit</button>
    <button data-testid={`${testId}-delete-btn`} onClick={onDelete} className="font-mono text-[11px] uppercase tracking-[0.2em] border border-[#FF5A5A]/50 text-[#FF5A5A] px-3 py-2 hover:bg-[#FF5A5A] hover:text-black">Delete</button>
  </div>
);
